<template>
  <span>
    <div v-if="$store.state.main.suggestions.length">
      <h3 style="page-break-before: always">
        {{ $t("ideas-and-suggestions") }}  
      </h3>
      <br/>
      <ul>
        <li v-for="suggestion in getSortedSuggestions" :key="suggestion.id">
          {{ getCaseNumber(suggestion)  }}{{ getName(suggestion) }}{{ suggestion.suggestion }}
        </li>
      </ul>
    </div>
    <br/>
  </span>
</template>

<script>

const sortby = require("lodash.sortby");

export default {
  data: function () {
    return {
      suggestions: [],
    };
  },
  computed: {
    getSortedSuggestions() {
      return sortby(this.$store.state.main.suggestions, [
        (o) => {
          // If comment given in begin page, there's
          // no case_number -> put in in top of the list
          return o.case_number ? o.case_number : 0;
        },
      ]);
    }
  },
  methods: {
    getName(suggestion) {
      if (suggestion.player) {
        const player = this.$store.getters.getPlayerById(suggestion.player);
        return player.nick_name + ": ";
      }
      return "";
    },
    getCaseNumber(suggestion) {
      if (suggestion.case_number) {
        return suggestion.case_number + ". ";
      }
      return "";
    }
  },
};
</script>

<i18n>
  {
    "en": {
      "ideas-and-suggestions": "Ideas and development suggestions"
    },
    "fi": {
      "ideas-and-suggestions": "Ideat ja toimenpide-ehdotukset"
    },
    "sv": {
      "ideas-and-suggestions": "Idéer och förslag"
    },
    "de": {
      "ideas-and-suggestions": "Ideen und Vorschläge"
    },
   "ko": {
      "ideas-and-suggestions": "아이디어 및 제안"
    }
  }
  </i18n>
